"use client";

import Image from "next/image";
import { Suspense, useState } from "react";
import { EventoPublicado } from "@/types";
import SkeletonEventoBanner from "./SkeletonEventoBanner";
import { CountdownBanner } from "../CountdownBanner";

interface Props {
  evento: EventoPublicado;
}

export default function EventoBanner({ evento }: Props) {
  const flyerFallback = "/bebop/placeholder/flyer_ticketera.png";

  const [mobileSrc, setMobileSrc] = useState(evento.flyer || flyerFallback);

  return (
    <div
      className="
        w-full
        grid grid-cols-1 md:grid-cols-2 gap-4
        md:aspect-auto
        md:rounded
      "
    >
      <Suspense fallback={<SkeletonEventoBanner />}>

        {/* IMAGE: Desktop + Mobile */}
        <div className="relative w-full aspect-[4/5] overflow-hidden md:rounded">
          <Image
            src={mobileSrc}
            alt={evento.nombre}
            fill
            priority
            sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 640px"
            className="object-contain bg-black md:bg-transparent"
            onError={() => setMobileSrc(flyerFallback)}
          />
        </div>

        {/* COUNTDOWN: Lado a lado en desktop, abajo en mobile */}
        <div className="flex items-start justify-center aspect-[4/5]  overflow-hidden md:rounded">
          <div className="w-full md:max-w-xs">
            <CountdownBanner />
          </div>
        </div>

      </Suspense>
    </div>
  );
}
